interface DiscordLinkParams {
    text?: string
}

export function DiscordLink({text = 'Discord'}: DiscordLinkParams) {
    return <a href='https://discord.gg/tnyGScTc6K' target='blank'>{text}</a>
}
